import { StateToken } from '@ngxs/store';

export const PROJECT_ALTERNATIVE_STATE_TOKEN = new StateToken<string | null>('alternative');
